/**
 * isartau — Video-Vorschau in der Galerie-Kachel (Auftrag 12.10.2026)
 * ---------------------------------------------------------------------------
 * Hochkant-Videos (9:16) standen am Desktop mit breiten weissen Balken in der
 * quadratischen Kachel. Jetzt: In der Kachel laeuft eine stumme Vorschau in
 * Schleife, randlos (Ausschnitt unten, seit 13.10.2026 — Untertitel), ohne
 * Steuerelemente. Ein Klick oeffnet die Lightbox direkt beim Video — dort
 * gilt das Lightbox-Verhalten (ganzes Hochformat, Ton, Start per Play).
 *
 * WIE DAWN ES AUSGIBT: In jeder Video-Kachel stehen zwei Dinge —
 *   A  <modal-opener> mit Standbild und Lightbox-Knopf
 *   B  <deferred-media>, das bei Klick IN der Kachel abspielt
 * Unter 750 px zeigt Dawn A, darueber B. Das Stylesheet
 * (snippets/galerie-video-vorschau-styles.liquid) zeigt jetzt auf allen
 * Breiten A. Dieses Skript legt in A ein eigenes <video> ueber das Standbild.
 *
 * REGELN:
 *   - "Bewegung reduzieren": gar kein Video, nur das Standbild.
 *   - Fassung: Kann der Browser den HLS-Stream (m3u8) selbst abspielen
 *     (Safari, also jedes iPhone), bekommt er ihn — der Stream waehlt fuer
 *     die kleine Kachel von sich aus eine kleine Qualitaet. Sonst mp4 nach
 *     Auftragsregel: 480p; fehlt sie, die naechstkleinere; gibt es keine
 *     kleinere, die kleinste vorhandene.
 *
 *     ⚠️ GEMESSEN 12.10.2026: Liquid (media.sources) liefert NUR m3u8 und
 *     die groesste mp4 (1080p, 4,8 Mbit/s). Die 480p- und 720p-Dateien
 *     liegen zwar auf dem CDN (Admin-API: Video.sources), Liquid nennt sie
 *     aber nicht. Fuer Chrome/Firefox am Desktop ist die "kleinste
 *     vorhandene" damit 1080p. Die Regel greift von selbst, sobald Shopify
 *     kleinere Fassungen herausgibt.
 *
 *     Liste aus snippets/galerie-video-vorschau.liquid; fehlt sie, Dawns
 *     Fassung aus dem <template>.
 *   - Laden und Abspielen erst, wenn die Kachel ins Bild kommt; anhalten,
 *     wenn sie es verlaesst, und solange die Lightbox offen ist.
 *   - Laedt oder spielt die Vorschau nicht: Das Video bleibt unsichtbar bzw.
 *     wird entfernt. Es bleibt das Standbild, ohne Meldung, ohne leere Kachel.
 *     Sichtbar wird das Video erst beim Ereignis "playing".
 *
 * Keine Dawn-Datei veraendert.
 */
(function () {
  'use strict';

  if (window.__isartauGalerieVideoVorschau) return;
  window.__isartauGalerieVideoVorschau = true;

  /* Bevorzugte Hoehe der Vorschau-Fassung in Pixeln (Shopify benennt die
     Fassungen nach der Hoehe: "SD-480p" ist bei Hochkant 270 x 480). */
  var ZIEL_HOEHE = 480;

  /* Anteil der Kachel, der sichtbar sein muss, damit die Vorschau laeuft. */
  var SICHTBAR_AB = 0.25;

  var KLASSE_VIDEO = 'galerie-vorschau-video';
  var KLASSE_LAEUFT = 'galerie-vorschau--laeuft';

  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[galerie-video-vorschau]');
    console.log.apply(console, a);
  }

  var weniger = window.matchMedia('(prefers-reduced-motion: reduce)');
  var quellen = null;
  var beobachter = null;
  var sichtbar = new Set();

  function quellenLesen() {
    if (quellen) return quellen;
    quellen = {};
    var el = document.querySelector('[data-galerie-video-quellen]');
    if (!el) return quellen;
    try {
      quellen = JSON.parse(el.textContent) || {};
    } catch (fehler) {
      log('Quellenliste nicht lesbar', fehler);
      quellen = {};
    }
    return quellen;
  }

  /**
   * 480p; sonst die naechstkleinere (groesste unter 480); sonst die
   * kleinste vorhandene.
   */
  function fassungWaehlen(liste) {
    if (!liste || !liste.length) return null;
    var genau = null;
    var darunter = null;
    var kleinste = null;
    liste.forEach(function (q) {
      /* Nur mp4 — der HLS-Stream (m3u8) spielt in Chrome nicht ohne
         Zusatzbibliothek. */
      if (!q || !q.u || q.f !== 'mp4') return;
      if (q.h === ZIEL_HOEHE && !genau) genau = q;
      if (q.h < ZIEL_HOEHE && (!darunter || q.h > darunter.h)) darunter = q;
      if (!kleinste || q.h < kleinste.h) kleinste = q;
    });
    var wahl = genau || darunter || kleinste;
    return wahl ? wahl.u : null;
  }

  /** HLS-Stream, aber nur wenn der Browser ihn ohne Zusatzbibliothek kann. */
  function streamWaehlen(video, liste) {
    if (!liste || !video.canPlayType('application/vnd.apple.mpegurl')) return null;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i] && liste[i].f === 'm3u8' && liste[i].u) return liste[i].u;
    }
    return null;
  }

  /** Rueckfall: die Fassung aus Dawns <template> in derselben Kachel. */
  function fassungAusDawn(container) {
    var vorlage = container.querySelector('deferred-media template');
    var quelle = vorlage && vorlage.content.querySelector('video source');
    return quelle ? quelle.getAttribute('src') : null;
  }

  function videoEntfernen(container) {
    var v = container.querySelector('video.' + KLASSE_VIDEO);
    container.classList.remove(KLASSE_LAEUFT);
    if (!v) return;
    if (beobachter) beobachter.unobserve(container);
    sichtbar.delete(container);
    v.pause();
    v.removeAttribute('src');
    v.load();
    v.remove();
  }

  function abspielen(container) {
    var v = container.querySelector('video.' + KLASSE_VIDEO);
    if (!v) return;
    if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.quelle);
    var versuch = v.play();
    /* Autoplay verweigert (Stromsparmodus, Browserregel): still beim
       Standbild bleiben. */
    if (versuch && versuch.catch) versuch.catch(function () {});
  }

  function anhalten(container) {
    var v = container.querySelector('video.' + KLASSE_VIDEO);
    if (v && !v.paused) v.pause();
  }

  function lightboxOffen() {
    var m = document.querySelector('product-modal.product-media-modal');
    return !!(m && m.hasAttribute('open'));
  }

  function vorschauAnlegen(container) {
    if (container.hasAttribute('data-galerie-vorschau-aus')) return;
    if (container.querySelector('video.' + KLASSE_VIDEO)) return;
    var ziel = container.querySelector('.product__modal-opener .product__media');
    var knopf = container.querySelector('.product__media-toggle[data-media-id]');
    if (!ziel || !knopf) return;

    var id = knopf.getAttribute('data-media-id');
    var v = document.createElement('video');
    var url = streamWaehlen(v, quellenLesen()[id]) || fassungWaehlen(quellenLesen()[id]) || fassungAusDawn(container);
    if (!url) return;

    v.className = KLASSE_VIDEO;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.controls = false;
    v.disablePictureInPicture = true;
    /* Erst beim Sichtbarwerden laden — die Quelle wartet in data-quelle. */
    v.preload = 'none';
    v.dataset.quelle = url;
    /* Rein schmueckend: Bedienung und Ansage uebernimmt Dawns Knopf. */
    v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1;

    v.addEventListener('playing', function () {
      container.classList.add(KLASSE_LAEUFT);
    });
    v.addEventListener('error', function () {
      if (!v.getAttribute('src')) return; /* eigenes Entladen, kein Fehler */
      log('Vorschau laedt nicht, Standbild bleibt', id);
      /* Merken, sonst legte der Galerie-Beobachter sie sofort neu an —
         eine Schleife aus Laden und Scheitern. */
      container.setAttribute('data-galerie-vorschau-aus', '');
      videoEntfernen(container);
    });

    ziel.appendChild(v);
    if (beobachter) beobachter.observe(container);
    log('Vorschau angelegt', id, url);
  }

  function alleKacheln() {
    return document.querySelectorAll(
      'media-gallery ul.product__media-list .product-media-container.media-type-video'
    );
  }

  function einrichten() {
    if (weniger.matches) return;
    Array.prototype.forEach.call(alleKacheln(), vorschauAnlegen);
  }

  function allesEntfernen() {
    Array.prototype.forEach.call(alleKacheln(), videoEntfernen);
  }

  /* =========================================================================
   * Sichtbarkeit und Lightbox
   * ======================================================================= */

  function beobachterAnlegen() {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) {
          sichtbar.add(e.target);
          if (!lightboxOffen()) abspielen(e.target);
        } else {
          sichtbar.delete(e.target);
          anhalten(e.target);
        }
      });
    }, { threshold: SICHTBAR_AB });
  }

  /* Dawn haelt beim Oeffnen und Schliessen der Lightbox ALLE Videos an
     (pauseAllMedia). Nach dem Schliessen laufen die sichtbaren Vorschauen
     deshalb hier wieder an. */
  var lightboxBeobachtet = null;
  function lightboxBeobachten() {
    var m = document.querySelector('product-modal.product-media-modal');
    if (!m || m === lightboxBeobachtet) return;
    lightboxBeobachtet = m;
    new MutationObserver(function () {
      if (m.hasAttribute('open')) {
        sichtbar.forEach(anhalten);
      } else {
        sichtbar.forEach(abspielen);
      }
    }).observe(m, { attributes: true, attributeFilter: ['open'] });
  }

  /* Dawn tauscht bei einem Variantenwechsel den Galerie-Inhalt aus. Neue
     Kacheln bekommen ihre Vorschau, sobald sie da sind. */
  var galerieBeobachtet = null;
  function galerieBeobachten() {
    var g = document.querySelector('media-gallery');
    if (!g || g === galerieBeobachtet) return;
    galerieBeobachtet = g;
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(function () {
        geplant = false;
        einrichten();
      });
    }).observe(g, { childList: true, subtree: true });
  }

  function start() {
    try {
      beobachter = beobachterAnlegen();
      if (!beobachter) return; /* ohne Sichtbarkeitspruefung lieber Standbild */
      einrichten();
      lightboxBeobachten();
      galerieBeobachten();

      var umschalten = function () {
        if (weniger.matches) allesEntfernen();
        else einrichten();
      };
      if (weniger.addEventListener) weniger.addEventListener('change', umschalten);
      else if (weniger.addListener) weniger.addListener(umschalten);

      document.addEventListener('product-info:loaded', function () {
        quellen = null;
        window.setTimeout(function () {
          einrichten();
          lightboxBeobachten();
          galerieBeobachten();
        }, 0);
      });
    } catch (fehler) {
      log('Start fehlgeschlagen', fehler);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
